import { app } from "../firebase";
import initializeStripe from "./initializeStripe";
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
} from "firebase/firestore";

const firestore = getFirestore(app);

export async function initializeCreateCheckoutSession(
  uid,
  productId,
  setLoading,
  isTrialAllowed
) {
  // Reference to the checkout_sessions collection
  const checkoutSessionsRef = collection(
    firestore,
    "users",
    uid,
    "checkout_sessions"
  );
  if (isTrialAllowed) {
    // Add a new checkout session document
    const docRef = await addDoc(checkoutSessionsRef, {
      allow_promotion_codes: true,
      price: productId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
      trial_period_days: 30,
      payment_method_collection: "if_required",
    });

    // Wait for the CheckoutSession to get attached by the extension
    onSnapshot(docRef, async (snap) => {
      const { sessionId } = snap.data();

      if (sessionId) {
        const stripe = await initializeStripe();
        const { error } = await stripe.redirectToCheckout({ sessionId });
        if (error) {
          alert(error.message);
        } else {
          setLoading(false); //sets button loading state in subscriptionModal,
        }
      }
    });
  }
  if (!isTrialAllowed) {
    // Add a new checkout session document
    const docRef = await addDoc(checkoutSessionsRef, {
      allow_promotion_codes: true,
      price: productId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
    });

    // Wait for the CheckoutSession to get attached by the extension
    onSnapshot(docRef, async (snap) => {
      const { sessionId } = snap.data();

      if (sessionId) {
        const stripe = await initializeStripe();
        const { error } = await stripe.redirectToCheckout({ sessionId });
        if (error) {
          alert(error.message);
        } else {
          setLoading(false); //sets button loading state in subscriptionModal,
        }
      }
    });
  }
}
